import React from "react"
import { CloseIcon } from "../../../icons"
import { RotatingButton } from "./rotating"

export interface CloseButtonProps {
  onClick?: () => void
  className?: string
  color?: string
  size?: string | number
}

export const CloseButton = ({ color, size, ...other }: CloseButtonProps) => {
  return (
    <RotatingButton {...other} icon={<CloseIcon color={color} size={size} />} />
  )
}
